import React, { FC } from 'react';
import './slide-avatar.sass';
import Logger from '../../../../../../../shared/utils/logger';
import { globalConfig } from '../../../../../../../shared/config/config';
import FileLinkClientService from '../../../../../../../shared/services/file-link-client.service';
import { Nullable } from '../../../../../../../shared/types/Typescript-utils';
import { IAuthor } from '../../../../../../../shared/types/Post';
import { InitialsAvatar } from '../../../../../../../shared/components/post/initials-avatar/initials-avatar';

interface ISlideAvatarProps {
  imageEffect?: Nullable<string>;
  author: Nullable<IAuthor>;
  genericAvatarConfig: {
    backgroundColor?: Nullable<string>;
    textColor?: Nullable<string>;
  };
}

export const SlideAvatar: FC<ISlideAvatarProps> = ({
  imageEffect,
  author,
  genericAvatarConfig: { backgroundColor, textColor },
}) => {
  let transformedImage = '';
  if (author && author.image_url) {
    try {
      const fileLinkClient = new FileLinkClientService({
        url: author.image_url,
        imageEffect: imageEffect,
        noImagesScaling: false,
      });

      transformedImage = fileLinkClient
        .applyEffect()
        .autoImage()
        .toString();
    } catch (error) {
      Logger.warning(error);
      transformedImage = 'wrongpath';
    }
  }

  return author ? (
    <a
      href={author.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${author.username || author.name} profile image`}
    >
      {author.image_url ? (
        <div
          className="slide-avatar"
          style={{
            backgroundImage: `url('${transformedImage}')`,
          }}
        />
      ) : transformedImage === '' && author.username && typeof author.username === 'string' ? (
        <InitialsAvatar
          initials={author.username.substring(0, 1)}
          textColor={textColor}
          backgroundColor={backgroundColor}
        />
      ) : null}
    </a>
  ) : null;
};
